import { persistentAtom } from "@nanostores/persistent";

export const $favoriteIds = persistentAtom<number[]>("favoriteCampsiteIds", [], {
  encode: (value) => value.join(","),
  decode: (value) => value.split(",").map(Number),
});

export function addToFavorites(favoriteId: number) {
  $favoriteIds.set([...$favoriteIds.get(), favoriteId]);
}

export function removeFromFavorites(favoriteId: number) {
  $favoriteIds.set($favoriteIds.get().filter((id) => id !== favoriteId));
}

export function toggleFavorite(favoriteId: number) {
  if (isFavorite(favoriteId)) {
    removeFromFavorites(favoriteId);
  } else {
    addToFavorites(favoriteId);
  }
}

export function isFavorite(favoriteId: number, favoriteIds = $favoriteIds.get()) {
  return favoriteIds.includes(favoriteId);
}
